import { createGlobalStyle } from "styled-components";
import variables, { smVariables } from "./variable";
import { GV, declearStyleVariables } from "../utils/style.util";

const GlobalStyle = createGlobalStyle`

	:root {
		${declearStyleVariables(variables)}
	}

	html {
		@media (max-width: 768px) {
			${declearStyleVariables(smVariables, "!important")}
		}
	}
	*, *::before, *::after {
		box-sizing: inherit;
		scroll-behavior: smooth;
	}
	h1, h2, h3, h4, h5, h6 {
		margin: 0;
	}
	p {
		margin:0;
	}
	a {
		text-decoration:none; 
		color:inherit; 
		cursor:pointer;
	}
	button {
		background-color:transparent;
		color:inherit;
		border-width:0;
		padding:0;
		cursor:pointer;
	}
	input::-moz-focus-inner { 
		border:0;
		padding:0;
		margin:0;
	}
	input, textarea {
		outline: 0;
	}
	ul, ol, dd {
		margin:0;
		padding:0;
		list-style:none;
	}
	cite {
		font-style:normal;
	}
	fieldset{
		border-width:0;
		padding:0;
		margin:0;
	}
	figure{
		margin:0;
	}

	html {
		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
	}

	body {
		margin: 0;
		box-sizing: border-box;
		font-family: 'Montserrat', sans-serif;
		background: ${GV('bg')};
		color: ${GV('color')};
		font-size: ${GV('font-size')};
		overflow-x: hidden;
	}

	article,
	aside,
	details,
	figcaption,
	figure,
	footer,
	header,
	hgroup,
	main,
	menu,
	nav,
	section,
	summary {
		display: block;
		margin: 0;
		padding: 0;
	}

	audio,
	canvas,
	progress,
	video {
		display: inline-block;
		vertical-align: baseline;
	}

	audio:not([controls]) {
		display: none;
		height: 0;
	}

	[hidden], template {
		display: none;
	}

	a {
		background-color: transparent;
	}

	a:active,
	a:hover {
		outline: 0;
	}

	abbr[title] {
		border-bottom: none;
		text-decoration: underline;
		text-decoration: underline dotted;
	}

	b,
	strong {
		font-weight: bold;
	}

	dfn {
		font-style: italic;
	}

	mark {
		background: #ff0;
		color: #000;
	}

	small {
		font-size: 80%;
	}

	sub,
	sup {
		font-size: 75%;
		line-height: 0;
		position: relative;
		vertical-align: baseline;
	}

	sup {
		top: -0.5em;
	}

	sub {
		bottom: -0.25em;
	}

	img {
		border: 0;
	}

	svg:not(:root) {
		overflow: hidden;
	}

	hr {
		box-sizing: content-box;
		height: 0;
	}

	pre {
		overflow: auto;
	}

	code,
	kbd,
	pre,
	samp {
		font-family: monospace, monospace;
		font-size: 1em;
	}

	button,
	input,
	optgroup,
	select,
	textarea {
		color: inherit;
		font: inherit;
		margin: 0;
	}

	button {
		overflow: visible;
	}

	button,
	select {
		text-transform: none;
	}

	button,
	html input[type="button"],
	input[type="reset"],
	input[type="submit"] {
		-webkit-appearance: button;
		-moz-appearance: button;
		appearance: button;
		cursor: pointer;
	}

	button[disabled],
	html input[disabled] {
		cursor: default;
	}

	button::-moz-focus-inner,
	input::-moz-focus-inner {
		border: 0;
		padding: 0;
	}

	input {
		line-height: normal;
	}

	input[type="checkbox"],
	input[type="radio"] {
		box-sizing: border-box;
		padding: 0;
	}

	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		height: auto;
	}

	input[type="search"] {
		-webkit-appearance: textfield;
		-moz-appearance: textfield;
		appearance: textfield;
		box-sizing: content-box;
	}

	input[type="search"]::-webkit-search-cancel-button,
	input[type="search"]::-webkit-search-decoration {
		-webkit-appearance: none;
	}

	fieldset {
		border: 1px solid #c0c0c0;
		margin: 0 2px;
		padding: 0.35em 0.625em 0.75em;
	}

	legend {
		border: 0;
		padding: 0;
	}

	textarea {
		overflow: auto;
	}

	optgroup {
		font-weight: bold;
	}

	table {
		border-collapse: collapse;
		border-spacing: 0;
	}

	td,
	th {
		padding: 0;
	}

	&::-webkit-scrollbar {
		position: absolute;
		width: 8px;
		height: 8px;
	}

	&::-webkit-scrollbar-track {
		background: #eee;
		border-radius: 5px;
		box-shadow: #eee;
	}

	&::-webkit-scrollbar-thumb {
		background: #a6a7c7ac;
		border-radius: 5px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #a6a7c7;
	}
	.slick-slider {
		max-width: 100%;
		width: 100%;
	}

	@media screen and (max-width:550px) {
		.landao-particle {
			width: 400px;
			height: 400px;
		}
	}

	@media screen and (max-width:450px) {
		.landao-particle {
			width: 300px;
			height: 300px;
		}
	}

	select {
		background-color: #161616;
		color: white;
		font-family: var(--body-font) !important;
		border: none;
		padding: 5px;
		width: 100%;
		height: 3.5rem;
		border-radius: 1rem;
		padding: 0 1rem;
    }
        
        /* Style the select box options */
	select option {
		background-color: #0A0A0A;
		color: white;
		border: none;
	}

	.alert {
		font-family: var(--body-font) !important;
	}

	.ant-notification-notice-content {
		font-family: var(--body-font);
	}

	.ant-btn {
		font-family: var(--body-font);
	}

	.ant-skeleton-paragraph li {
		background-color: #424242 !important;
	}

	.ant-modal-content {
		background-color: #161616 !important;
	}

	.ant-modal-header {
		background-color: #161616 !important;
		color:white !important;
	}

	.ant-modal-title {
		color: #ffffff !important;
	}

	.ant-notification-notice {
		background-color: #161616 !important;
	}

	.ant-notification-notice-message {
		color: white !important;
	}
	
	.ant-notification-notice-description {
		color: white !important;
	}

	.ant-notification-notice-close-x {
		color: white;
	}

	.ant-modal-close {
		color:white !important;
	}

	.ant-table-content {
		font-family: var(--body-font);
	}

	.ant-pagination-item a {
		color: white !important;
		font-family: var(--body-font);
	}

	.ant-pagination-item-active {
		background-color: #161616 !important;
	}

	.anticon svg {
		fill: white;
		stroke: white;
	}

	.ant-select-selector {
		font-family: var(--body-font) !important;
		background-color: #161616 !important;
		color: #e7e6e6 !important;

	}

	.ant-select-item-option-content {
		font-family: var(--body-font) !important;
	}

	.ant-table-content {
		background-color: #161616;
		color: #e7e6e6;
	}

	.ant-table-cell {
		border-bottom: none !important;
	}

	.ant-table-cell-row-hover {
		background-color: #1E1E24 !important;
	}
	
	th.ant-table-cell {
		background-color: #1E1E24 !important;
		color: white !important;
		border-bottom:1px solid #161616 !important;
	}
	
	th.ant-table-cell::before {
		all: unset !important;
	}

	.ant-select-dropdown {
		background-color: #161616;
	}
	
	.ant-select-item-option-content {
		color: #e7e6e6 !important;
	}

	.ant-select-item-option-active .ant-select-item-option-content {
		color: #1DAEFF !important;
	}

	.ant-table-placeholder .ant-table-cell {
		background-color: #161616;
	}

	.ant-table-placeholder:hover > td {
		background-color: #161616 !important;
	}

	.ant-empty-description {
		color: white !important;
	}

	.ant-table-content table {
		background-color: #161616;
	}

	.ant-pagination {
	}
`

export default GlobalStyle;
